import React, { useEffect, useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import { FormControl, Select, MenuItem } from '@mui/material';
import utils from 'components/utils';

const SelectDepot = props => {
	const { item } = props;
	const iCan = utils.usePermissions();
	const amcaUsersDepots = useStoreState(state => state.cart.open.uniqueCADepost);
	const singleUserDepots = utils.useUserData('availableDepots', []);
	const availableDepots = iCan('OPERATE_ON_MULTIPLE_CA') ? amcaUsersDepots : singleUserDepots;
	const saveNewDepot = useStoreActions(dispatch => dispatch.cart.deleted.saveNewDepot);

	const handleChange = event => {
		saveNewDepot({ catalog: item.catalog, depot: event.target.value });
	};

	return (
		<FormControl size="small">
			<Select
				value={item.depotNew}
				autoWidth
				sx={{
					height: '30px',
					fontFamily: ['"Poppins", sans-serif'].join(','),
					fontSize: '14px',
					fontWeight: '400'
				}}
				onChange={handleChange}
			>
				{availableDepots.map((depot, index) => (
					<MenuItem key={index} value={depot.id}>
						{depot.description}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default SelectDepot;
